<template>
  <v-container>
    <error-message ref="errorDialog" />
    <v-layout row wrap>
      <v-flex xs12>
        <select-link-menu :menus="linkMenus" @select-link-menu="setLinkMenu" />
      </v-flex>
      <sorter v-if="mypage_flg" @sort="sortByUser" :mypage_flg="mypage_flg" />
      <template v-if="graphList.length > 0">
        <v-flex xs12 v-for="(graph, index) in graphList" :key="index">
          <graph
            :graph="graph"
            @click-edit-button="clickEditButton"
            @click-delete-button="clickDeleteButton"
          />
          <v-divider
            v-if="index < graphList.length - 1"
            :key="'divider' + index"
            class="divider"
          ></v-divider>
        </v-flex>
      </template>
      <v-flex xs12 v-else>
        <v-card flat>
          <not-found>グラフはまだありません</not-found>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isOpenDialog" max-width="290">
      <v-card>
        <v-card-text>
          {{ targetGraph.title }}グラフを削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                color="#fadd70"
                @click="clickDeleteOkButton"
                class="dialogBtn"
                >はい</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                color="black"
                flat="flat"
                @click="isOpenDialog = false"
                class="dialogBtn"
                >キャンセル</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// グラフ部品
import Graph from "@/components/parts/GraphWithHr.vue";
import NotFound from "@/components/parts/404.vue";
// セレクトメニュー部品
import SelectMenu from "@/views/mypage/SelectMenu.vue";
// リンクメニュー部品
import SelectLinkMenu from "@/views/mypage/SelectLinkMenu.vue";
import Sorter from "@/components/Sorter.vue";
import dayjs from "dayjs";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    graph: Graph,
    "select-menu": SelectMenu,
    "select-link-menu": SelectLinkMenu,
    Sorter,
    NotFound,
    ErrorMessage
  },
  data: function() {
    return {
      isOpenDialog: false,
      targetGraph: {},
      graphList: [],
      selectedSortColumn: {},
      selectedSortOrder: {},
      selectedLinkMenu: {},
      linkMenus: [
        {
          key: "completed",
          value: "完成グラフ",
          isActive: true
        },
        {
          key: "drafted",
          value: "下書きグラフ",
          isActive: false
        }
      ],
      mypage_flg: true,
      collateGraphId: 0
    };
  },
  methods: {
    /**
     * グラフ一覧を設定する
     */
    async setGraphList() {
      this.graphList = [];
      // グラフ一覧を取得します
      await this.getGraphList();
    },
    getGraphList() {
      const graph_list = [];
      const EP = "/v1/users/" + this.$store.state.login.user_id + "/graphs";

      /* 急上昇用のEPが出来たら /v1/graphs/new-arrivals だけ修正します */
      return this.$http
        .get(EP, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          // ページの状態を見て公開フラグの可否を変更します
          let flg_completed = true;
          if (this.selectedLinkMenu.key == "drafted") {
            flg_completed = false;
          }

          for (const key in res.data) {
            if (res.data[key].publish_flg == flg_completed) {
              this.graphList.push(res.data[key]);
            }
          }
        })
        .catch(error => {
          this.graphList = [];
          this.$refs.errorDialog.setMessage(
            "グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    /**
     * リンクメニューが設定、変更された場合、一覧を更新する
     */
    setLinkMenu(arg0) {
      this.selectedLinkMenu = arg0;
      this.setGraphList();
    },
    setDrawType(graphId) {
      const EP = "/v1/graphs/" + graphId;
      return this.$http
        .get(
          EP,
          {
            id: graphId
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.login.auth_token
            }
          }
        )
        .then(res => {
          let drawType = "edit";
          if (res.data.collate_graph_id) {
            drawType = "overwrite";
            this.collateGraphId = res.data.collate_graph_id;
          }
          return drawType;
        })
        .catch(error => {
          this.graphList = [];
          this.$refs.errorDialog.setMessage(
            "グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    /**
     * グラフ編集画面を表示する
     */
    async clickEditButton(graphId) {
      const drawType = await this.setDrawType(graphId);
      if (drawType == "overwrite") {
        this.$router.push({
          name: "overwrite",
          query: { id: this.collateGraphId, mine: graphId }
        });
      } else {
        this.$store.commit("setGraphType", "edit");
        this.$router.push({ name: "create", query: { id: graphId } });
      }
    },
    /**
     * グラフを削除する。
     * 引数のgraphIdは子から上がってきた値。
     */
    clickDeleteButton(graphId) {
      this.targetGraph = this.graphList.find(
        graph => graph.graph_id === graphId
      );

      // 削除対象のグラフが見つかったら削除ダイアログを開く
      if (Object.keys(this.targetGraph).length) {
        this.isOpenDialog = true;
      }
    },
    /**
     * 削除ダイアログの「はい」が押されたら呼ばれる。
     * サーバに削除リクエストを出し、レスポンスが返ってきたらダイアログを閉じて、リストを再描画する。
     */
    clickDeleteOkButton() {
      const EP = "/v1/graphs/" + this.targetGraph.graph_id;
      this.$http
        .delete(EP, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.isOpenDialog = false;
          this.setGraphList();
        })
        .catch(error => {
          this.graphList = [];
          this.$refs.errorDialog.setMessage(
            "グラフの削除に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    // 日付の比較もあるため引き算方法は使わない
    sortByUser(sortKey, order) {
      this.graphList.sort((a, b) => {
        if (order === -1) {
          if (a[sortKey] > b[sortKey]) {
            return -1;
          }
          return 1;
        }
        if (a[sortKey] > b[sortKey]) {
          return 1;
        }
        return -1;
      });
    }
  },
  beforeCreate: function() {
    const isLogin = this.$store.state.twitter_account.is_login;
    // ログインしていない場合は、トップ画面に戻す
    if (!isLogin) {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
.dialogBtn {
  width: 100%;
}

.divider {
  width: 100%;
  margin: 20px 0;
  border: none;
  border-top: dashed 1px #ff9933;
}
</style>
